import { IOrderDetailsStateResponse } from '../state/order-details';
import { ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS } from './action-types';
import {
    IAsyncFetchableAction,
    IAsyncAction,
    IAsyncErrorAction,
    AsyncActionState,
} from '@telstra-connect/standard-actions/async-action';

export interface ILoadOrderProductDetailsAction
    extends IAsyncFetchableAction<ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS> {}

export interface ILoadOrderProductDetailsSuccessAction
    extends IAsyncAction<ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS> {
    data: IOrderDetailsStateResponse
}

export type LoadOrderProductDetailsErrorAction =
    IAsyncErrorAction<ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS>;

export interface ILoadOrderProductDetailsResetAction
    extends IAsyncAction<ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS> {
}

export const loadOrderProductDetailsStart =
    (): ILoadOrderProductDetailsAction => ({
        status: AsyncActionState.Initiated,
        type: ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS,
        isFetchable: true,
    });

export const loadOrderProductDetailsSuccess = (
    data: IOrderDetailsStateResponse
): ILoadOrderProductDetailsSuccessAction => ({
    status: AsyncActionState.Success,
    type: ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS,
    data,
});

export const loadOrderProductDetailsError = (
    error: string
): LoadOrderProductDetailsErrorAction => ({
    status: AsyncActionState.Failure,
    type: ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS,
    error,
});

export const loadOrderProductDetailsReset = (
): ILoadOrderProductDetailsResetAction => ({
    status: AsyncActionState.NotStarted,
    type: ORDER_TRACKER_LOAD_ORDER_PRODUCT_DETAILS,
});
